/**
 * Recharge Legacy Widget — Persist Frequency on Variant Change
 * 
 */

(function () {
  'use strict';

  var savedFrequency = null;

  var DROPDOWN_SELECTOR = '.rc-selling-plans-dropdown__select';
  var WIDGET_SELECTOR = '.rc-widget';

  /**
   * Attach a change listener to the frequency dropdown so we capture
   * whatever the customer selects.
   */
  function attachDropdownListener(dropdown) {
    if (!dropdown || dropdown.dataset.frequencyListenerAttached) return;

    dropdown.addEventListener('change', function () {
      savedFrequency = dropdown.value;
      console.log('[RC Persist] Customer selected frequency:', savedFrequency);
    });

    dropdown.dataset.frequencyListenerAttached = 'true';
  }

  /**
   * After the widget re-renders (variant change), try to restore the
   * previously selected frequency. We retry a few times because the
   * widget may take a moment to fully render the new options.
   */
  function restoreFrequency(attempts) {
    if (!savedFrequency) return;

    attempts = attempts || 0;
    var MAX_ATTEMPTS = 15;
    var RETRY_DELAY = 200; // ms

    var dropdown = document.querySelector(DROPDOWN_SELECTOR);

    if (!dropdown) {
      if (attempts < MAX_ATTEMPTS) {
        setTimeout(function () {
          restoreFrequency(attempts + 1);
        }, RETRY_DELAY);
      }
      return;
    }

    var optionExists = Array.from(dropdown.options).some(function (opt) {
      return opt.value === savedFrequency;
    });

    if (optionExists && dropdown.value !== savedFrequency) {
      dropdown.value = savedFrequency;

      // Dispatch events so Recharge's internal Vue logic registers the change
      dropdown.dispatchEvent(new Event('change', { bubbles: true }));
      dropdown.dispatchEvent(new Event('input', { bubbles: true }));

      console.log('[RC Persist] Restored frequency to:', savedFrequency);
    } else if (!optionExists) {
      console.log(
        '[RC Persist] Previously selected frequency "' +
          savedFrequency +
          '" is not available for this variant. Keeping default.'
      );
    }

    // Re-attach listener to the new dropdown
    attachDropdownListener(dropdown);
  }

  /**
   * Use a MutationObserver on the widget element to detect when
   * the widget re-renders (which happens on variant change).
   */
  function observeWidgetReRenders(widget) {
    var debounceTimer = null;

    var observer = new MutationObserver(function () {
      // Debounce
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        restoreFrequency();
      }, 300);
    });

    observer.observe(widget, {
      childList: true,
      subtree: true,
    });

    console.log('[RC Persist] Observing widget for re-renders');
  }

  /**
   * Also listen for the "Subscribe & save" radio being clicked,
   * because if a customer switches from one-time back to subscribe,
   * the dropdown re-appears and we should restore.
   */
  function observeSubscriptionRadio() {
    var radios = document.querySelectorAll('input[name="purchaseOption"]');
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.value === 'subscription' && savedFrequency) {
          // Small delay so the dropdown renders
          setTimeout(function () {
            restoreFrequency();
          }, 400);
        }
      });
    });
  }

  /**
   * Initialise: find the dropdown and widget, attach listeners, start observing.
   * We poll because the Recharge widget loads asynchronously.
   */
  function init(attempts) {
    attempts = attempts || 0;
    var MAX_ATTEMPTS = 30;
    var RETRY_DELAY = 500; // ms

    var dropdown = document.querySelector(DROPDOWN_SELECTOR);
    var widget = document.querySelector(WIDGET_SELECTOR);

    if (dropdown && widget) {
      attachDropdownListener(dropdown);
      observeWidgetReRenders(widget);
      observeSubscriptionRadio();
      console.log('[RC Persist] Initialised successfully');
      return;
    }

    if (attempts < MAX_ATTEMPTS) {
      setTimeout(function () {
        init(attempts + 1);
      }, RETRY_DELAY);
    } else {
      console.log('[RC Persist] Could not find Recharge widget after max attempts');
    }
  }

  // Kick off once the DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
})();